module.exports = __webpack_public_path__ + "img/logo_movie.4bb9dab4.png";